
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

export const usePermissionGuard = (requiredClaims: string[]) => {
    const { Permission } = useSelector((state: RootState) => state.login.userData);
    const hasPermission = requiredClaims.every(claim => Permission?.includes(claim));
    return hasPermission;
};